import { Col, Row } from "react-bootstrap"
import React from "react"
import { CompetitionPageHeader } from "@components/Competition/CompetitionPageHeader/CompetitionPageHeader"
import { CompetitionAPI } from "../../../src/apis/CompetitionAPI"
import { getNavigationProps } from "@components/Navigation/getNavigationProps"
import { RSS, SEO } from "../../../src/types/next.js"
import InferNextPropsType from "infer-next-props-type"
import { ParsedUrlQuery } from "querystring"
import { GetStaticPropsContext } from "next"
import * as NextConstants from "constants/next"
import { CompetitionConstants } from "../../../src/constants/competitions"
import { CompetitionTeams } from "@components/Competition/CompetitionTeams/CompetitionTeams"
import { SeasonAPI } from "../../../src/apis/SeasonAPI"
import { TeamAPI } from "../../../src/apis/TeamAPI"
import { MatchAPI } from "../../../src/apis/MatchAPI"
import { getCompetitionCanonicalData, getRedirectCompetition } from "utils/competition"
import { SeasonConstants } from "../../../src/constants/seasons"
import { NewTitleBanner } from "@components/Banners/NewTitleBanner"
import homeLastMatches from "@assets/images/title-banner/home-last-matches.png"
import homeTeams from "@assets/images/title-banner/home-teams.png"
import homeGroup from "@assets/images/title-banner/home-group.png"
import homeStandings from "@assets/images/title-banner/home-standings.png"
import { CompetitionSeasonGroupSelector } from "@components/Competition/CompetitionSeasonGroupSelector/CompetitionSeasonGroupSelector"
import { GroupAPI } from "../../../src/apis/GroupAPI"
import { LocalizedMatch } from "../../../src/types/match"
import { CompetitionSeasonAPI } from "../../../src/apis/CompetitionSeasonAPI"
import CompetitionDescriptionText from "@components/SeoTextComponents/CompetitionDescriptionText/Index"
import { GroupStandingOld } from "@components/Competition/GroupStandingOld"
import { TurnMatches } from "@components/Turn/TurnMatches"

export default function CompetitionPage({
  competitionCalciocomSlug,
  groupCalciocomSlug,
  turnMatches,
  teams,
  seasonCalciocomSlug,
  competitionDetail,
  groups,
  groupsWithStandings,
  groupWithStandingsSlug,
  turn,
  recentMatches,
  competitionDescription,
  teamStandings,
}: InferNextPropsType<typeof getStaticProps>) {
  return (
    <>
      <Row>
        <CompetitionPageHeader
          selected="generale"
          competitionCalciocomSlug={competitionCalciocomSlug}
          competition={competitionDetail}
          showCompetitionInfo={true}
          showAll={turnMatches.length > 0}
        />
      </Row>
      <Row className="marginZero">
        <Col md={12} lg={6} className="paddingLeftZero">
          <NewTitleBanner title="Classifica" icon={homeStandings} col={{ lg: 12 }} />
          <div className="hs-select new-hs-select">
            {groupsWithStandings.length > 1 && (
              <CompetitionSeasonGroupSelector
                competitionCalciocomSlug={competitionCalciocomSlug}
                seasonCalciocomSlug={seasonCalciocomSlug}
                groupCalciocomSlug={groupWithStandingsSlug!}
                groups={groupsWithStandings}
                page={"classifica"}
              />
            )}
          </div>
          <GroupStandingOld
            hiddenParameters={["GF:GS", "DIF"]}
            competitionCalciocomSlug={competitionCalciocomSlug}
            seasonCalciocomSlug={seasonCalciocomSlug}
            teamStandings={teamStandings}
          />
        </Col>
        <Col md={12} lg={6} className="marginZero paddingRightZero championshipColumn">
          <NewTitleBanner title="Squadre" icon={homeTeams} col={{ lg: 12 }} />
          <CompetitionTeams
            competitionCalciocomSlug={competitionCalciocomSlug}
            seasonCalciocomSlug={seasonCalciocomSlug}
            teams={teams}
          />
        </Col>
      </Row>
      <Row>
        <Col md={12} lg={6} className="marginZero paddingLeftZero">
          <div id="hs-content" className={"hs-border-div paddingZero"}>
            {turnMatches.length > 0 ? (
              <div className="hs-block hs-teams">
                <NewTitleBanner title="Ultime partite" icon={homeLastMatches} col={{ lg: 12 }} />
                <TurnMatches matches={turnMatches} loading={false} />
              </div>
            ) : (
              <div className="new-calendario-risultati">
                <div className="new-title-banner-container">
                  <NewTitleBanner title={"Ultime partite"} icon={homeGroup} col={{ lg: 12 }} />
                </div>
                <div className="hs-select new-hs-select">
                  {groups.length > 1 && (
                    <CompetitionSeasonGroupSelector
                      competitionCalciocomSlug={competitionCalciocomSlug}
                      seasonCalciocomSlug={seasonCalciocomSlug}
                      groupCalciocomSlug={groupCalciocomSlug}
                      groups={groups}
                      page={"calendario-risultati"}
                    />
                  )}
                </div>
                {turn && <TurnMatches matches={recentMatches} loading={false} />}
              </div>
            )}
          </div>
        </Col>
        <Col md={12} lg={6} className="marginZero paddingRightZero championshipColumn">
          <div id="hs-content" className={"hs-border-div paddingZero"}>
            {recentMatches.length > 0 && (
              <div className="new-calendario-risultati">
                <div className="new-title-banner-container">
                  <NewTitleBanner title={"Prossime partite"} icon={homeGroup} col={{ lg: 12 }} />
                </div>
                <div className="hs-select new-hs-select">
                  {groups.length > 1 && (
                    <CompetitionSeasonGroupSelector
                      competitionCalciocomSlug={competitionCalciocomSlug}
                      seasonCalciocomSlug={seasonCalciocomSlug}
                      groupCalciocomSlug={groupCalciocomSlug}
                      groups={groups}
                      page={"calendario-risultati"}
                    />
                  )}
                </div>
                {turn && <TurnMatches matches={recentMatches} loading={false} />}
              </div>
            )}
          </div>
        </Col>
      </Row>
      <CompetitionDescriptionText
        competitionName={competitionDetail.name}
        competitionDescription={competitionDescription}
      />
    </>
  )
}

export async function getStaticPaths() {
  return { paths: [], fallback: "blocking" }
}

interface IParams extends ParsedUrlQuery {
  competitionCalciocomSlug: string
  //seasonCalciocomSlug: string
}

export async function getStaticProps(context: GetStaticPropsContext<IParams>) {
  try {
    const { competitionCalciocomSlug } = context.params!
    const [competitionIds] = await Promise.all([
      CompetitionAPI.getCompetitionIds(competitionCalciocomSlug),
      //SeasonAPI.getSeasonIds(seasonCalciocomSlug),
    ])
    //const competitionIds = await CompetitionAPI.getCompetitionIds(competitionCalciocomSlug)
    const [competition, navigationProps, competitionDetail] = await Promise.all([
      CompetitionAPI.getCompetition(competitionIds.id),
      getNavigationProps(competitionIds.id),
      CompetitionAPI.getLastSeasonCompetitionDetails(competitionIds.id),
    ])
    const { groupSlug, turnSlug } = await getRedirectCompetition(competition)

    const seasons = await SeasonAPI.getSeasonsByCompetitionId(competition.id)
    let season = seasons[0]

    const currentSeason = seasons.find((season) => season.year === SeasonConstants.CURRENT_SEASON_YEAR)
    if (currentSeason) {
      season = currentSeason
    }

    const [turnMatches, teams] = await Promise.all([
      MatchAPI.getPlayedMatches(competitionIds.id, season.id),
      TeamAPI.getTeams(competitionIds.id, season.id),
    ])

    const competitionSeasonId = await CompetitionSeasonAPI.getIdByCompetitionIdAndSeasonId(competition.id, season.id)
    const groups = await SeasonAPI.getPhaseGroups(competitionSeasonId)
    const groupsWithStandings = groups.filter((g) => g.hasStanding).sort((a, b) => a.name.localeCompare(b.name))

    const group = await GroupAPI.getGroup(groups.find((group) => group.calciocomSlug === groupSlug)!.id)

    const turn = (group.turns && group.turns.filter((t) => t.calciocomSlug == turnSlug)[0]) || null
    let recentMatches: LocalizedMatch[] = []
    const teamStandings = groupsWithStandings[0]
      ? await GroupAPI.getTeamStandings(groupsWithStandings[0].id, undefined)
      : []

    if (turn) {
      recentMatches = await MatchAPI.getRecentMatches(competitionIds.id, season.id, turn.id)
      //recentMatches = await MatchAPI.getNextMatches(competitionSeasonId, turn.id)
    }

    const title = competition.metaTitle || `${competition.name} : Calendario, statistiche e risultati`
    const competitionDescription = competition.description
    const seo: SEO = {
      title: title,
      description:
        competition.metaDescription ||
        `Segui la ${competition.name} su Calcio.com. Statistiche, calendari , risultati live e scontri diretti per rimanere sempre aggiornato sul campionato`,
      keywords: [`${competition.name}`, "Squadre", "calcio"],
      ...(await getCompetitionCanonicalData(
        competition,
        null,
        null,
        null,
        `/campionato/${competitionCalciocomSlug}/generale`,
      )),
    }

    let rss: RSS | null = null
    if (CompetitionConstants.TOP_COMPETITIONS_IDS.includes(competition.id)) {
      rss = {
        competitionCalcioComSlug: competitionCalciocomSlug,
      }
    }

    return {
      props: {
        competitionDescription: competitionDescription,
        competitionCalciocomSlug: competitionCalciocomSlug,
        seasonCalciocomSlug: season.calciocomSlug!,
        groupCalciocomSlug: groupSlug!,
        teams,
        turnMatches: turnMatches.slice(-10),
        competitionDetail,
        navigationProps,
        title,
        seo,
        rss,
        groups,
        groupsWithStandings: groupsWithStandings,
        groupWithStandingsSlug: groupsWithStandings[0]?.calciocomSlug || null,
        turn,
        recentMatches,
        teamStandings,
      },
      revalidate: NextConstants.REVALIDATE,
    }
  } catch (error) {
    console.error(error)
    return {
      notFound: true,
    }
  }
}
